import { defineStore } from "pinia";

export const useInterimsStore = defineStore('interimsModule', {
    state: () => ({
        fetching: false,
        allInterimsFetched: false,
    }),
    actions: {
        startFetching() {
            this.fetching = true;
        },
        endFetching() {
            this.fetching = false;
        },
        setAllInterimsFetched() {
            this.allInterimsFetched = true;
        },
    },
});
